import { openDB as openIDB } from 'idb';

const DB_NAME = 'CircleCuttingFactoryERP';
const DB_VERSION = 1;

export const openDB = async () => {
  return openIDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('syncQueue')) {
        const syncQueue = db.createObjectStore('syncQueue', { keyPath: 'id' });
        syncQueue.createIndex('status', 'status');
        syncQueue.createIndex('timestamp', 'timestamp');
      }
      
      if (!db.objectStoreNames.contains('parties')) {
        const parties = db.createObjectStore('parties', { keyPath: 'id' });
        parties.createIndex('name', 'name');
      }
      
      if (!db.objectStoreNames.contains('coilIns')) {
        const coilIns = db.createObjectStore('coilIns', { keyPath: 'id' });
        coilIns.createIndex('party_id', 'party_id');
      }
    },
  });
};

export const saveToLocal = async (storeName, data) => {
  const db = await openDB();
  const tx = db.transaction(storeName, 'readwrite');
  await tx.objectStore(storeName).put(data);
  await tx.done;
};

export const getFromLocal = async (storeName, id) => {
  const db = await openDB();
  return await db.get(storeName, id);
};

export const getAllFromLocal = async (storeName) => {
  const db = await openDB();
  return await db.getAll(storeName);
};
